import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=3b8749d9&scoped=true&"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8749d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VRow,VSpacer})
